import { render, staticRenderFns } from "./checkList.vue?vue&type=template&id=4fa55935&"
import script from "./checkList.vue?vue&type=script&lang=js&"
export * from "./checkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports